import eduCommonApi from "./edu-api-common";
import eduCoursesApi from "./edu-courses-api";
import eduMembersApi from "./edu-members-api";
import eduOrgsApi from "./edu-orgs-api";
import eduProjectsApi from "./edu-projects-api";
import eduPublicCoursesApi from "./edu-public-courses-api";
import eduTeachingPlansApi from "./edu-teaching-plans-api";

export * from "./edu-api-common";
export * from "./edu-courses-api";
export * from "./edu-members-api";
export * from "./edu-orgs-api";
export * from "./edu-projects-api";
export * from "./edu-public-courses-api";
export * from "./edu-teaching-plans-api";

export const eduApi = {
  ...eduCommonApi,
  ...eduCoursesApi,
  ...eduTeachingPlansApi,
  ...eduMembersApi,
  ...eduOrgsApi,
  ...eduProjectsApi,
  ...eduPublicCoursesApi,
};
